import styled from "@emotion/styled";
import {CardErrorContainer} from "../ui/cardContainer";
import errorIcon from "../img/error.svg"; 
import {Main} from "../layout";

const TitleText = styled.p`
    font-size: 34px;
    margin: 0;
    color: #a83a3a;
    text-align: center;
    font-family: "Lato", sans-serif;
    font-weight: 600;

    @media (max-width: 480px) {
        font-size: 26px;
    }
`;

const ErrorMessage = styled.p`
    font-size: 18px;
    color: #5a1f1f;
    text-align: center;
    margin: 10px 0 0;
    font-family: "EBENYA", sans-serif;
    font-weight: 400;

    @media (max-width: 480px) {
        font-size: 16px;
    }
`;

const ErrorImgContainer = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;

    img {
        width: 38%;
        filter: drop-shadow(0 8px 18px rgba(248, 59, 59, 0.69));
    }
`;

const ContentContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-content: center;
    gap: 30px;

    @media (max-width: 480px) {
        padding: 100px 0 0;
        gap: 20px;
    }
`;

export const Failed = () => {
    return (
        <Main>
            <CardErrorContainer>
                <ContentContainer>
                    <ErrorImgContainer>
                        <img src={errorIcon} alt="error"/>
                    </ErrorImgContainer>
                    <TitleText>Оплата не прошла</TitleText>
                    <ErrorMessage>К сожалению, произошла ошибка при обработке платежа. Попробуйте снова.</ErrorMessage>
                </ContentContainer>
            </CardErrorContainer>
        </Main>
    );
};